import { MddHttpService } from 'app/core';
import { GetAccessToken } from '../oauth';

export class GetImage {
    private mddHttpService: MddHttpService;
    private getAccessToken: GetAccessToken;

    constructor(mddHttp: MddHttpService) {
        this.getAccessToken = new GetAccessToken();
        this.mddHttpService = mddHttp;
    }

    execute(url: string): Promise<string | undefined> {
        return this.mddHttpService
            .request<void, string>(
                {
                    url: url,
                    headers: {
                        Authorization: `Bearer ${this.getAccessToken.execute()!.token}`
                    }
                },
                'text'
            )
            .then((x) => x.body);
    }
}
